var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"mb-4",class:{
    'pr-24' : _vm.item.status !== 'Submitted',
    'pl-24' : _vm.item.status === 'Submitted'
  }},[_c(_vm.requestType,{tag:"component",attrs:{"item":_vm.item}}),_vm._v(" "),_c('p',{staticClass:"mt-1 text-2xs text-grey-800 italic",class:{
      'text-right' : _vm.item.status === 'Submitted'
    },domProps:{"innerHTML":_vm._s(_vm.stamp)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }